import { useEffect, useState } from 'react';

import useLADProcessorList from '../../../redux/hooks/useLADProcessorList';
import FormSelectBox from '../Inputs/FormSelectBox';

const LADClaimProcessorSelector = ({
  placeholder = 'Select Claim Processor',
  label = 'Claim Processor',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  className = '',
  tabIndex,
  mode = '',
  disableValidation = false,
  isRemoved = false,
}) => {
  const [options, setOptions] = useState([]);
  const processorList = useLADProcessorList();

  useEffect(() => {
    if (processorList?.length >= 0) {
      const options = processorList.map((row) => ({
        label: row.userName,
        value: row.userID,
      }));
      setOptions(options);
    } else {
      setOptions([]);
    }
  }, [processorList]);

  return (
    <FormSelectBox
      loading={processorList === undefined}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      mode={mode}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
      isRemoved={isRemoved}
    />
  );
};

export default LADClaimProcessorSelector;
